export default __webpack_public_path__ + "static/pic1-aa727212155146c52d4d9ed06cbd5a1d.jpg";